const getCommonStyles = ({ size }) => ({
  padding: size === 'small' ? '8px' : '12px',
  fontSize: size === 'small' ? '0.875rem' : '1rem',
  fontWeight: '400',
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  borderRadius: '4px',
  height: size === 'small' ? '32px' : '40px',
  maxHeight: size === 'small' ? '32px' : '40px',
  minWidth: 'unset',
  '&.MuiLoadingButton-loading': {
    color: 'transparent!important',
  },

  svg: {
    width: '16px',
  },
});

export default {
  button: ({ size, color }) => ({
    ...getCommonStyles({ size }),
    color: '#fff',
    backgroundColor: (theme) =>
      color === 'error'
        ? theme.palette.reds.codingRed400
        : theme.palette.blues.primaryBlue,

    '&:hover': {
      backgroundColor: (theme) =>
        color === 'error'
          ? theme.palette.reds.codingRed900
          : theme.palette.blues.primaryBlue600,
    },
    '&:focus': {
      backgroundColor: (theme) =>
        color === 'error'
          ? theme.palette.reds.codingRed900
          : theme.palette.blues.primaryBlue700,
    },
    '&:disabled': {
      color: (theme) =>
        color === 'error' ? '#fff' : theme.palette.blues.primaryBlue400,
      backgroundColor: (theme) =>
        color === 'error'
          ? theme.palette.reds.codingRed400
          : theme.palette.blues.primaryBlue100,
    },
    '& .MuiLoadingButton-loadingIndicator': {
      color: (theme) => theme.palette.blues.primaryBlue400,
    },
  }),
  outlinedButton: ({ size, color }) => ({
    ...getCommonStyles({ size }),
    color: (theme) =>
      color === 'error'
        ? theme.palette.reds.codingRed400
        : theme.palette.blues.primaryBlue500,

    backgroundColor: '#fff',
    border: (theme) =>
      `1px solid ${
        color === 'error'
          ? theme.palette.reds.codingRed400
          : theme.palette.blues.primaryBlue
      }`,
    '&:hover': {
      backgroundColor: (theme) =>
        color === 'error' ? theme.palette.reds.codingRed100 : '#fff',
      color: (theme) =>
        color === 'error'
          ? theme.palette.reds.codingRed400
          : theme.palette.blues.primaryBlue700,
      border: (theme) =>
        `1px solid ${
          color === 'error'
            ? theme.palette.reds.codingRed400
            : theme.palette.blues.primaryBlue700
        }`,
    },
    '&:focus': {
      backgroundColor: (theme) =>
        color === 'error' ? theme.palette.reds.codingRed100 : '#fff',
      color: (theme) =>
        color === 'error'
          ? theme.palette.reds.codingRed400
          : theme.palette.blues.primaryBlue700,
      border: (theme) =>
        `1px solid ${
          color === 'error'
            ? theme.palette.reds.codingRed400
            : theme.palette.blues.primaryBlue700
        }`,
    },
    '&:disabled': {
      color: (theme) => theme.palette.blues.primaryBlue400,
      backgroundColor: '#fff',
      border: (theme) =>
        `1px solid ${
          color === 'error'
            ? theme.palette.reds.codingRed400
            : theme.palette.blues.primaryBlue400
        }`,
    },

    '& .MuiLoadingButton-loadingIndicator': {
      color: (theme) =>
        color === 'error'
          ? theme.palette.reds.codingRed400
          : theme.palette.blues.primaryBlue400,
    },
  }),
  textButton: ({ color, size }) => ({
    ...getCommonStyles({ size }),
    fontWeight: 700,
    fontSize: '0.875rem',
    padding: '0',
    height: 'auto',
    color: (theme) =>
      color === 'error'
        ? theme.palette.reds.codingRed400
        : theme.palette.blues.primaryBlue500,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
      color: (theme) =>
        color === 'error'
          ? theme.palette.reds.codingRed900
          : theme.palette.blues.primaryBlue600,
    },
    '&:focus': {
      backgroundColor: 'transparent',
      color: (theme) =>
        color === 'error'
          ? theme.palette.reds.codingRed900
          : theme.palette.blues.primaryBlue600,
    },
    '&:disabled': {
      opacity: 0.5,
      backgroundColor: 'transparent',
    },
    '& .MuiLoadingButton-loadingIndicator': {
      color: (theme) => theme.palette.blues.primaryBlue400,
    },
  }),
  secondaryButton: ({ size }) => ({
    ...getCommonStyles({ size }),
    padding: '12px',
    color: (theme) => theme.palette.blues.primaryBlue500,

    backgroundColor: '#fff',
    border: (theme) => `1px solid ${theme.palette.blues.primaryBlue}`,
    '&:hover': {
      backgroundColor: (theme) => theme.palette.blues.lightestBlue,
      color: (theme) => theme.palette.blues.primaryBlue500,
      border: (theme) => `1px solid ${theme.palette.blues.primaryBlue}`,
    },
    '&:focus': {
      backgroundColor: (theme) => theme.palette.blues.primaryBlue100,
      color: (theme) => theme.palette.blues.primaryBlue500,
      border: (theme) => `1px solid ${theme.palette.blues.primaryBlue}`,
    },
    '& .MuiLoadingButton-loadingIndicator': {
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
    '&:disabled': {
      color: (theme) => theme.palette.grays.gray400,
      backgroundColor: '#fff',
      border: (theme) => `1px solid ${theme.palette.grays.gray400}`,
      '&.MuiLoadingButton-loading': {
        border: (theme) => `1px solid ${theme.palette.blues.primaryBlue400}`,
      },
    },
  }),
};
